import { Card, Modal, styled, CardContent, CardActions, Button } from "@mui/material";
import useSession from "hooks/call-queue/useSession";
import useApi from "hooks/useApi";
import useFirebase from "hooks/useFirebase";
import { CallStatus } from "types/auth";

const ScreenshotCard = styled(Card)(({ theme }) => ({
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    p: 4,
    zIndex: 10000000
}));

const Screenshot = styled('img')(({ theme }) => ({
    width: '300px',
    height: 'auto'
}));

const ScreenshotModal = ({ setScreenshot, screenshot }: { setScreenshot: (set: any) => void, screenshot: { url: string; base64: string; file: File | string } | null}) => {
    const { uploadAsset, uploadScreenshot, user, showToast } = useApi();
    const { session } = useSession();
    const { addScreenshot, addCallHistoryEntry } = useFirebase();

    const uploadScreenshotToTxn = async () => {

        try{
        let uploaded = await uploadAsset(screenshot?.file as File, `transaction/${session?.transaction}`);
        let { success, data, message } = uploaded;
        if(success){
            let dataClone = { ...data };
            delete dataClone.url;
            let screenshotUploaded = await uploadScreenshot(session?.transaction!, dataClone);
            let { success: uploadSuccess, message } = screenshotUploaded;
            if(uploadSuccess){
                addScreenshot(session?.transaction!, data);
                addCallHistoryEntry(session!.transaction!, {
                    status: CallStatus.SUPPORT_SCREENSHOT,
                    datetime: new Date().toISOString(),
                    user: user!.uid
                });
                setScreenshot(null);
                showToast('Screenshot has been saved', 'success');
            }else{
                showToast(message, 'error');
            }
        }else{
            showToast(message, 'error');
        }
        }catch(error: any){
            showToast(error.message, 'error');
        }
    }

    return (
        <Modal
            open={true}
            onClose={() => {
                setScreenshot(null);
            }}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <ScreenshotCard>
                <CardContent sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <Screenshot src={screenshot?.url} />
                </CardContent>
                <CardActions sx={{ justifyContent: 'end'}}>
                    <Button onClick={() => {
                        setScreenshot(null);
                    }} color="error">
                        Discard
                    </Button>
                    <Button onClick={uploadScreenshotToTxn} variant="contained" color="primary">
                        Upload
                    </Button>
                </CardActions>
            </ScreenshotCard>
        </Modal>
    )
}

export default ScreenshotModal;